<div class="page in-signin-wrapper">
  <img src="../../assets/img/brand/appblender.png" width="150" alt="logo"
    style="position: absolute; top: 1rem; left: 1rem;">
  <div class="d-flex justify-content-between align-items-center mainContainer">
    <div class="d-flex flex-column descriptionColumn">
      <div class="text-center">
        <h1 class="header-brand-logo text-white">
          One Place For Opportunity<br> Providers & Candidates</h1>
      </div>
    </div>
    <div class="d-flex flex-column inputColumn">
      <div class="d-flex justify-content-end toastContainerPosition">
        <app-toast-container aria-live="polite" aria-atomic="true"></app-toast-container>
      </div>
      <div class="clearfix"></div>
      <div class="d-flex justify-content-center align-items-center">
        <div class="text-center">
          <h1 class="header-brand-logo text-white">
            <img src="/assets/img/brand/logo-white.png" alt="Logo" style="max-width: 120px !important;">
          </h1>


        </div>
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="Submit()" novalidate class="loginForm mt-4">
        <div class="form-group text-start text-white">
          <label>Username or Email</label>
          <input class="form-control text-white" formControlName="username" type="text">
          <div *ngIf="(loginFormControl.username.touched || submitted) && (loginFormControl.username.errors?.required)"
            class="tx-danger">
          </div>
        </div>
        <div class="form-group text-start text-white position-relative">
          <label>Password</label>
          <div class="d-flex justify-content-end align-items-center">
            <input class="form-control text-white" formControlName="password" type="{{inputType}}">
            <i class="fa fa-eye{{pView}} text-white me-3" aria-hidden="true" (click)="viewPassword()"></i>
          </div>

          <div *ngIf="(loginFormControl.password.touched || submitted) && (loginFormControl.password.errors?.required)"
            class="tx-danger">
          </div>
        </div>
        <button class="btn ripple colored-btn btn-block text-white" [disabled]="!loginForm.valid || processingRequest">
          <i class="pi pi-spin pi-spinner mx-2" *ngIf="processingRequest" type="submit"></i>Sign In</button>

        <label class="text-sm mt-2 text-white">By logging in, you agree to our <a href="#" class="text-gray">Terms &
            Conditions</a></label>
      </form>
      <!-- <div class="text-start mt-2 ms-0">
                <div class="mb-1"><a href="javascript:;" class=" text-white">Forgot password?</a></div>
                <div>Don't have an account? <a href="javascript:;">Register Here</a></div>
            </div> -->
    </div>
  </div>
  <!-- <div class="card">
        <div class="row row-sm">
            <div class="col-lg-6 col-xl-5 d-none d-lg-block text-center bg-primary details">
                <div class="mt-5 pt-4 p-2 pos-absolute">
                    <h1 class="header-brand-logo mb-5">
                        &#10100; App Blender &#10101;</h1>
                    <div class="clearfix"></div>
                    <img src="../../assets/img/svgs/user.svg" class="ht-100 mb-0" alt="user">
                    <h5 class="mt-4 text-white">Your management companion</h5>
                    <span class="tx-white-6 tx-13 mb-5 mt-xl-0">Signin to create, discover and connect with
                                the global community</span>
                </div>
            </div>
            <div class="col-lg-6 col-xl-7 col-xs-12 col-sm-12 login_form ">
                <div class="container-fluid">
                    <div class="row row-sm">
                        <div class="card-body mt-2 mb-2">
                            <img src="../../assets/img/brand/logo.png" class=" d-lg-none header-brand-img text-start float-start mb-4" alt="logo">
                            <div class="clearfix"></div>
                            <form [formGroup]="loginForm" (ngSubmit)="Submit()" novalidate>
                                <h5 class="text-start mb-5">Access Your Account</h5>
                                <div class="form-group text-start">
                                    <label>Email or Username</label>
                                    <input class="form-control" formControlName="username" type="text">
                                    <div *ngIf="(loginFormControl.username.touched || submitted) && (loginFormControl.username.errors?.required)" class="tx-danger">
                                        <small>Enter spruha@demo.com to login</small>
                                    </div>
                                </div>
                                <div class="form-group text-start">
                                    <label>Password</label>
                                    <input class="form-control" formControlName="password" type="password">
                                    <div *ngIf="(loginFormControl.password.touched || submitted) && (loginFormControl.password.errors?.required)" class="tx-danger">
                                        <small>Enter above password</small>
                                    </div>
                                </div>
                                <button class="btn ripple btn-main-primary btn-block" [disabled]="!loginForm.valid || processingRequest"> <i
                                                class="pi pi-spin pi-spinner mx-2" *ngIf="processingRequest"></i>Sign
                                            In</button>
                            </form>
                            <div class="text-start mt-5 ms-0">
                                <div class="mb-1"><a href="javascript:;">Forgot password?</a></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div> -->

  <!-- End Row -->

</div>
